import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { EventsService, UtilService, VariablesService } from '../../shared/services';

@Component({
  selector: 'app-nudge-login',
  templateUrl: './nudge-login.component.html',
  styleUrls: ['./nudge-login.component.scss']
})
export class NudgeLoginComponent implements OnInit {

  hideNudge = false;
  @Output() hide = new EventEmitter<any>();
  text;
  isMobile;
  isIos;

  constructor(
    public vars: VariablesService,
    public eventService: EventsService,
    public util: UtilService
  ) { }

  ngOnInit(): void {
    this.isMobile = this.util?.isMobile();
    this.isIos = this.util.isIOSDevice();
    this.util.currency.subscribe((res) => {
      if (res === 'INR') {
        this.text = 'Save a life with just ₹10 on the Ketto App. ';
      } else {
        this.text = 'Mini-contribution with a MEGA impact: Save lives on Ketto app as well. ';
      }
    });
  }

  appDownloadEvent() {
    const payload: any = {
      eventName: 'login_nudge_app_download',
      page_name: this.vars.pageName,
      info_2: this.isIos ? 'iOS' : 'android'
    };
    this.eventService.sendSystemEvent(payload).subscribe(_ => _);
  }

  close() {
    this.hideNudge = true;
    this.hide.emit(this.hideNudge);
  }

}
